import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { api } from "./api";
import { Header } from "./components/Header";
import { AdminPage } from "./pages/AdminPage";
import { AboutPage } from "./pages/AboutPage";
import { AlertsPage } from "./pages/AlertsPage";
import { ExplorePage } from "./pages/ExplorePage";
import { ProjectPage } from "./pages/ProjectPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { SignInPage, VerifyPage } from "./pages/SignInPage";
import type { SessionUser } from "./types";

export default function App() {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [sessionReady, setSessionReady] = useState(false);
  useEffect(() => {
    api<{ user: SessionUser | null }>("/api/auth/session").then(({ user: next }) => setUser(next)).finally(() => setSessionReady(true));
  }, []);
  if (!sessionReady) return <div className="page-loader">Austin Home Permits</div>;
  const signedOut = () => setUser(null);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<><Header user={user} onSignOut={signedOut} /><ExplorePage user={user} /></>} />
        <Route path="/about" element={<><Header user={user} onSignOut={signedOut} /><AboutPage /></>} />
        <Route path="/projects/:id" element={<><Header user={user} onSignOut={signedOut} showCreateAlert={false} /><ProjectPage user={user} /></>} />
        <Route path="/sign-in" element={<><Header user={user} onSignOut={signedOut} /><SignInPage /></>} />
        <Route path="/auth/verify" element={<VerifyPage onAuthenticated={setUser} />} />
        <Route path="/onboarding" element={<><Header user={user} onSignOut={signedOut} />{user ? user.needsOnboarding ? <OnboardingPage user={user} onUpdated={setUser} /> : <Navigate to="/profile" replace /> : <Navigate to="/sign-in" replace />}</>} />
        <Route path="/alerts/new" element={<><Header user={user} onSignOut={signedOut} /><AlertsPage user={user} onAuthenticated={setUser} /></>} />
        <Route path="/alerts" element={<><Header user={user} onSignOut={signedOut} />{user ? user.needsOnboarding ? <Navigate to="/onboarding?next=/alerts/new" replace /> : <AlertsPage user={user} onAuthenticated={setUser} /> : <Navigate to="/sign-in" replace />}</>} />
        <Route path="/profile" element={<><Header user={user} onSignOut={signedOut} />{user ? user.needsOnboarding ? <Navigate to="/onboarding" replace /> : <AlertsPage user={user} onAuthenticated={setUser} /> : <Navigate to="/sign-in" replace />}</>} />
        <Route path="/admin" element={user?.isAdmin ? <AdminPage user={user} onSignOut={() => setUser(null)} /> : <Navigate to="/sign-in" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
